<app-base-modal [dialogTitle]="data?.rimsStepSchema?.stepName ?? ''" (closeEvent)="onClose()">
  <div class="rims-edit-panel-wrapper">
    <section class="rims-steps-tree">
      <mat-tree #tree [dataSource]="dataSource$" [childrenAccessor]="childrenAccessor">
        <!-- Nodes without children (Field -->
        <mat-tree-node
          *matTreeNodeDef="let node"
          matTreeNodePadding
          matTreeNodePaddingIndent="16"
          [ngClass]="{
            node: true,
            'node-active': nodeAsRimsFieldsTreeType(node).objectPath === selectedRimsStepPropertyTree?.objectPath,
          }"
          (click)="onRimsStepPropertyTreeSelectedAsync(node)"
        >
          <div class="node-inner node-inner-without-arrow">
            <p class="title">{{ nodeAsRimsFieldsTreeType(node).displayName }}</p>
          </div>
        </mat-tree-node>

        <!-- Nodes with children (Collection of Objects or Object with Object fields) -->
        <!-- ::IMPORTANT:: If the "when:" part is true, this mat-tree-node renders in stead of the one above -->
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
          matTreeNodePaddingIndent="16"
          [isExpandable]="true"
          (expandedChange)="onNodeExpandedChange(node, $event)"
          [cdkTreeNodeTypeaheadLabel]="nodeAsRimsFieldsTreeType(node).name"
          [ngClass]="{
            node: true,
            'node-with-child': true,
            'node-active': nodeAsRimsFieldsTreeType(node).objectPath === selectedRimsStepPropertyTree?.objectPath,
          }"
          (click)="onRimsStepPropertyTreeSelectedAsync(node?.originalNode ?? node)"
        >
          <div class="node-inner node-inner-with-arrow">
            <button class="tree-button" matIconButton matTreeNodeToggle>
              <mat-icon>{{ tree.isExpanded(node) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            </button>
            <p class="title">{{ nodeAsRimsFieldsTreeType(node).displayName }}</p>
          </div>
        </mat-tree-node>
      </mat-tree>
    </section>

    <section class="rims-step-attributes">
      @if (selectedRimsStepPropertyTree) {
        <div class="rims-step-attributes-header">
          <h4>{{ selectedRimsStepPropertyTree.displayName }}</h4>
          <p>{{ selectedRimsStepPropertyTree.description }}</p>
        </div>

        <div class="rims-step-attributes-content">
          @if (!this.incidentsPageStore?.isEditMode()) {
            <!-- Show selected field value or all subfields when object type -->
            @for (
              rimsStepPropertyTree of getRimsStepPropertyTreesBasedOnPropertyType();
              track rimsStepPropertyTree.objectPath
            ) {
              <div class="rims-step-attributes-content-row">
                <p class="rims-step-attributes-content-title">{{ rimsStepPropertyTree?.displayName }}</p>
                @if (getPropertyType(rimsStepPropertyTree.schema) === 'object' && rimsStepPropertyTree.value) {
                  <button
                    class="button-primary"
                    mat-flat-button
                    (click)="onRimsStepPropertyTreeSelectedAsync(rimsStepPropertyTree)"
                  >
                    Open
                  </button>
                } @else {
                  <p class="rims-step-attributes-content-value">
                    {{ getRimsStepPropertyTreeDisplayValue(rimsStepPropertyTree) }}
                  </p>
                }
              </div>
            }
          } @else {
            <!-- In edit mode -->
            @if (getPropertyType(selectedRimsStepPropertyTree.schema) === 'array') {
              <!-- Show the Set editing list. Add/remove set entries -->
              <div class="set-add-remove-section">
                <div class="set-items-with-button-container">
                  <div class="set-items">
                    @for (setEntry of getSetEntries; track $index) {
                      <div class="set-item">
                        <div class="set-item-text">Entry {{ $index + 1 }}</div>
                        <button class="set-item-remove" (click)="removeSetEntry($index)" type="button">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                  </div>

                  <button class="button-primary add-set-item-button" (click)="addSetEntry()" mat-flat-button>
                    <mat-icon>add</mat-icon>Add new
                  </button>
                </div>
              </div>
            } @else {
              <!-- Show respective form with editable fields based on the selected item structure -->
              <div class="rims-step-attributes-content-form">
                @if (activeFormGroup()) {
                  <app-rims-form (requestFormChange)="onRimsStepPropertyTreeSelectedAsync($event.rawFieldData)" />
                }
              </div>
            }
          }
        </div>
      }
    </section>
  </div>
  @if (this.incidentsPageStore?.isEditMode()) {
    <!-- Save and Cancel buttons -->
    <!-- This is projected by the ng-content of the app-base-modal -->
    <div panel-footer>
      <button class="button-secondary" mat-flat-button class="button-link" (click)="onClose()">Cancel</button>
      <!-- Sending an empty array in the onUpdate() because we don't have a specific field edited. Instead we want the structure to be updated with the new or removed set items -->
      <button
        class="button-primary"
        mat-flat-button
        [disabled]="formBuilderService.hasInvalidForms()"
        (click)="onUpdate(formBuilderService.getTouchedForms())"
      >
        Update
      </button>
    </div>
  }
</app-base-modal>
